const getStyles = () => {
    return {
        column: {
        },

        container: {
        },

        row: {
        },
    };
};

export default getStyles;
